// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./static/c_prt.css
// module id = 9IOW
// module chunks = 1